exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2BdPe{background:#f44336}._2BdPe,._3Q8WH{display:inline-block;color:#fff;border-radius:3px;padding:2px 5px}._3Q8WH{background:#4caf50}._2LiYk,._2YX4b,._3FKFQ,._33VeL,.ANLz2{margin:0;padding:3px 10px;border:1px solid #efefef;background:#fff;color:#b4b4b4;text-align:center;cursor:pointer}._2YX4b,._3FKFQ{border-radius:5px}._3FKFQ{margin-top:10px;padding:10px 20px}._33VeL{border-top-left-radius:5px;border-bottom-left-radius:5px}._2LiYk,._33VeL{border-right:none}.ANLz2{border-top-right-radius:5px;border-bottom-right-radius:5px}._2LiYk:hover,._2YX4b:hover,._3FKFQ:hover,._33VeL:hover,.ANLz2:hover{background:#efefef}[class^=ReactTable]{background-color:#fff}", ""]);

// exports
exports.locals = {
	"teal": "#00dcb2",
	"grey": "#b4b4b4",
	"orange": "#ff4e32",
	"sick": "#673ab7",
	"vacation": "#cddc39",
	"holiday": "#4caf50",
	"labelNo": "_2BdPe",
	"labelYes": "_3Q8WH",
	"buttonSingle": "_2YX4b",
	"buttonSingleLarge": "_3FKFQ",
	"buttonLeft": "_33VeL",
	"buttonMiddle": "_2LiYk",
	"buttonRight": "ANLz2"
};